// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"21ebb34a","563":"9a5d245f","778":"4595fb25"}[chunkId] + ".chunk.js";
};